import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import FaqSection from "../components/FaqSection";
import contactSectionImage from "./../assets/contact-section-image.png";
import { homeDesktopItems, homeMobileItems } from "../data/mockData.js";
import Footer from "../components/Footer.js";
import B2BContactLeadForm from "../components/B2BContactLeadForm.js";

const GetStarted = () => {

  return (
    <div className="min-h-screen bg-white">
      <Navbar desktopItems={homeDesktopItems} mobileItems={homeMobileItems} />
      <main className="pl-0 md:pl-6">
        {/* Page layout: sidebar + content */}
        <div className="flex gap-1">
          {/* Sidebar */}
          <Sidebar />
          {/* Content */}
          <div className="flex-1">
            {/* HERO SECTION */}
            <section className="mt-10 rounded-[10px] px-3 md:px-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center md:items-start">
                <div className="order-1 md:order-2 md:justify-self-end w-full">
                  <div className="w-full h-[440px] sm:h-[700px] rounded-[10px] overflow-hidden relative">
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="h-[90%] rounded-[8px] overflow-hidden">
                        <img
                          src={contactSectionImage}
                          alt="Eveness solutions hero"
                          className="w-full h-full object-contain"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="order-2 md:order-1 max-w-[520px]">
                  <h2 className="text-[32px] leading-[34px] md:text-[44px] md:leading-[52px] font-normal text-black tracking-[-1.44px] font-inter">
                    The Eveness Solution
                  </h2>

                  <p className="mt-5 max-w-[420px] font-normal text-[13px] leading-[23.4px] tracking-[0.17px] align-middle text-[#1A1A1A]">
                    The Eveness API "free tier" offers immediate access with no
                    sign-up call required. To unlock your own branded GPT,
                    advanced data systems, and an algorithm that works on
                    collection pages please{" "}
                    <a
                      href="#"
                      className="text-[#1A1A1A] hover:text-black font-normal text-[13px] leading-[23.4px] tracking-[0.17px] align-middle underline underline-offset-[4px] decoration-solid"
                    >
                      schedule a call
                    </a>{" "}
                    . Our aim is to empower the fashion industry and assist in
                    creating happier customers that shop more and return less.
                  </p>

                  <B2BContactLeadForm />
                </div>
              </div>
              <div className="mt-[52px]">
                <FaqSection />
              </div>
            </section>
            <Footer/>
          </div>
        </div>
      </main>
    </div>
  );
};

export default GetStarted;
